import { nextTick, watch, type Ref } from 'vue';
import { yandexTrackingService } from '@/entities/analytics';
import type { SearchCriteria } from '@/entities/searchCriteria';
import { getSerpHitKey } from '../lib/serpHitTracking';

export interface SerpHitTracking {
  trackSearchStart: (criteria: SearchCriteria) => void;
}

export function useSerpHitTracking(criteria: Readonly<Ref<SearchCriteria>>): SerpHitTracking {
  let lastSearchKey: string | null = null;
  let urlBeforeCriteriaChange: string | null = null;
  let pendingHitReferer: string | null = null;
  let isFlushScheduled = false;

  watch(
    criteria,
    () => {
      if (typeof window === 'undefined') return;

      urlBeforeCriteriaChange ??= window.location.href;
    },
    { flush: 'sync' },
  );

  const flush = (): void => {
    if (pendingHitReferer !== null) {
      yandexTrackingService.hit(window.location.href, { referer: pendingHitReferer, title: document.title });
    }

    isFlushScheduled = false;
    urlBeforeCriteriaChange = null;
    pendingHitReferer = null;
  };

  const trackSearchStart = (searchCriteria: SearchCriteria): void => {
    const searchKey = getSerpHitKey(searchCriteria);

    if (lastSearchKey !== null && searchKey !== lastSearchKey) {
      pendingHitReferer ??= urlBeforeCriteriaChange ?? window.location.href;
    }

    lastSearchKey = searchKey;

    if (isFlushScheduled) return;

    isFlushScheduled = true;
    nextTick(flush);
  };

  return { trackSearchStart };
}
